// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').ToastNotifications} ToastNotifications
 * @typedef {import('../types/system').SystemNotifications} SystemNotifications
 */

/**
 * @type {function(PlottrState): SystemNotifications}
 */
const notificationSelector = createSelector(fullSystemStateSelector, ({ notifications }) => {
  return (
    notifications ?? {
      message: null,
      timeout: null,
      toast: {
        cardAction: null,
        newBookId: null,
        visible: false,
        lineAction: null,
      },
    }
  )
})

/**
 * @type {function(PlottrState): ToastNotifications}
 */
export const toastNotificationSelector = createSelector(
  notificationSelector,
  (notifications) => notifications.toast
)
/**
 * @type {function(PlottrState): (String | Null)}
 */
export const messageSelector = createSelector(
  notificationSelector,
  (notifications) => notifications.message
)
/**
 * @type {function(PlottrState): (ReturnType<typeof setTimeout> | Null)}
 */
export const timeoutSelector = createSelector(
  notificationSelector,
  (notifications) => notifications.timeout
)
